<template>
  <div :id="random_id" :data-testid="props.dataTestid">
    <TsCard>
      <TsRow gutter="2">
        <TsColumn
          v-for="item in data"
          :key="item.id"
          class="flex flex-col justify-center items-center"
        >
          <TsTypography :data-testid="props.dataTestid + '_heading'" as="h3">{{
            item.heading
          }}</TsTypography>
          <TsTypography
            :data-testid="props.dataTestid + '_subHeading'"
            as="h5"
            >{{ item.subHeading }}</TsTypography
          >
          <TsTypography
            :data-testid="props.dataTestid + '_description'"
            appendClass="text-center"
            >{{ item.description }}</TsTypography
          >
        </TsColumn>
      </TsRow>
    </TsCard>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRandomUUID } from "../../composables/useRandomUUID";

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

type dataObject = {
  id?: number;
  heading?: string;
  subHeading?: string;
  description?: string;
};

type Props = {
  data?: dataObject[];
  dataTestid?: string;
};

const props = withDefaults(defineProps<Props>(), {
  data: [
    {
      id: 1,
      heading: "550",
      subHeading: "Stores",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut",
    },
    {
      id: 2,
      heading: "25000+",
      subHeading: "Products",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut",
    },
    {
      id: 3,
      heading: "60",
      subHeading: "Lorem ipsum",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut",
    },
  ],
});

const random_id = ref("");
onMounted(() => {
  random_id.value = useRandomUUID();
});
</script>
